import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccountRouterProps } from "../AccountRouterProps";
import { AccountLayout } from "../AccountLayout";
import { AccountEntities } from "../AccountEntities";

interface SessionViewPageProps extends NSARouterMakerResult, AccountRouterProps
{ }

export default function SessionViewPage(props: SessionViewPageProps) 
{
	return (
		<AccountLayout {...props}
			pages={{
				entity: AccountEntities.session(props),
				ui: {
					action: {
						menus: {
							view_history: false
						}
					}
				},
				view: {
					ui: {
						tab_page_view: {
							tabs: {
								history: false
							}
						}
					}
				}
			}}
		>
			<></>
		</AccountLayout>
	);
};